import { Capacitor } from '@capacitor/core';

/**
 * Utility helpers for Capacitor native platform detection and features
 */
export const isNativePlatform = () => Capacitor.isNativePlatform();
export const getPlatform = () => Capacitor.getPlatform(); // 'ios' | 'android' | 'web'
export const isIOS = () => getPlatform() === 'ios';
export const isAndroid = () => getPlatform() === 'android';

/**
 * Initialize native plugins when running on a real device
 */
export const initNativeApp = async () => {
  if (!isNativePlatform()) return;

  // Mark HTML as native for CSS overrides
  document.documentElement.classList.add('native-app');
  try {
    // Status Bar
    const { StatusBar, Style } = await import('@capacitor/status-bar');
    await StatusBar.setStyle({ style: Style.Dark });
    if (isAndroid()) {
      await StatusBar.setBackgroundColor({ color: '#0c1220' });
      await StatusBar.setOverlaysWebView({ overlay: false });
    }

    // Keyboard
    const { Keyboard } = await import('@capacitor/keyboard');
    Keyboard.addListener('keyboardWillShow', () => {
      document.body.classList.add('keyboard-open');
    });
    Keyboard.addListener('keyboardWillHide', () => {
      document.body.classList.remove('keyboard-open');
    });

    // Splash Screen — hide after app is ready
    const { SplashScreen } = await import('@capacitor/splash-screen');
    await SplashScreen.hide({ fadeOutDuration: 300 });
  } catch (e) {
    console.warn('[Capacitor] Plugin init warning:', e);
  }
};

/**
 * Trigger a light haptic feedback (for button taps, etc.)
 */
export const hapticLight = async () => {
  if (!isNativePlatform()) return;
  try {
    const { Haptics, ImpactStyle } = await import('@capacitor/haptics');
    await Haptics.impact({ style: ImpactStyle.Light });
  } catch {}
};

export const hapticMedium = async () => {
  if (!isNativePlatform()) return;
  try {
    const { Haptics, ImpactStyle } = await import('@capacitor/haptics');
    await Haptics.impact({ style: ImpactStyle.Medium });
  } catch {}
};
